export default {
  getSiwfData: state => state.siwfData,
};
